import type * as api from '@gitbook/api-client';
import { Switch, Tooltip, toast } from '@gitbook/spine-react';

import { apiClient } from '../../state';

/**
 * Toggle button to mute/unmute the creation of change requests for a cluster of issues.
 */
export function ConversationsIssuesClusterToggle(props: {
    organizationId: string;
    cluster: api.ConversationsIssuesCluster;
}) {
    const { organizationId, cluster } = props;

    return (
        <Tooltip
            label={
                cluster.muted
                    ? 'Resume the creation of change requests for this cluster of issues'
                    : 'Pause the creation of change requests for this cluster of issues'
            }
        >
            <div>
                <Switch
                    value={!cluster.muted}
                    onValueChange={async () => {
                        await toast.catch(async () => {
                            await apiClient.conversations.updateConversationsIssuesCluster(
                                organizationId,
                                cluster.id,
                                {
                                    muted: !cluster.muted,
                                }
                            );
                        }, 'Error while muting/unmuting the creation of change requests for this cluster of issues');
                    }}
                />
            </div>
        </Tooltip>
    );
}
